(function () {
  if (window.BoyaCustomTabProducts) {
    window.BoyaCustomTabProducts.initAll(document);
    return;
  }

  function initSection(section) {
    if (!section || section.dataset.tabsBound === '1') return;
    section.dataset.tabsBound = '1';

    var buttons = Array.prototype.slice.call(section.querySelectorAll('.tab-btn'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.tab-panel'));
    var tabsNav = section.querySelector('.tabs-nav');
    var scrollStateFrame = 0;

    function getMaxScrollLeft() {
      if (!tabsNav) return 0;
      return Math.max(0, tabsNav.scrollWidth - tabsNav.clientWidth);
    }

    function updateScrollState() {
      if (!tabsNav) return;
      var edgeTolerance = 2;
      var maxScrollLeft = getMaxScrollLeft();
      var isOverflowing = maxScrollLeft > edgeTolerance;
      tabsNav.classList.toggle('is-overflowing', isOverflowing);
      tabsNav.classList.toggle('can-scroll-left', isOverflowing && tabsNav.scrollLeft > edgeTolerance);
      tabsNav.classList.toggle('can-scroll-right', isOverflowing && tabsNav.scrollLeft < maxScrollLeft - edgeTolerance);
    }

    function scheduleScrollStateUpdate() {
      if (scrollStateFrame) return;
      scrollStateFrame = window.requestAnimationFrame(function () {
        scrollStateFrame = 0;
        updateScrollState();
      });
    }

    function positionActiveTab(button, behavior) {
      if (!tabsNav || !button) return;

      window.requestAnimationFrame(function () {
        updateScrollState();
        var maxScrollLeft = getMaxScrollLeft();
        var buttonIndex = buttons.indexOf(button);
        var targetScrollLeft = 0;

        if (maxScrollLeft <= 2 || buttonIndex <= 0) {
          targetScrollLeft = 0;
        } else if (buttonIndex === buttons.length - 1) {
          targetScrollLeft = maxScrollLeft;
        } else {
          var navRect = tabsNav.getBoundingClientRect();
          var buttonRect = button.getBoundingClientRect();
          targetScrollLeft = tabsNav.scrollLeft
            + buttonRect.left
            + (buttonRect.width / 2)
            - navRect.left
            - (navRect.width / 2);
          targetScrollLeft = Math.max(0, Math.min(maxScrollLeft, targetScrollLeft));
        }

        if (typeof tabsNav.scrollTo === 'function') {
          tabsNav.scrollTo({ left: Math.round(targetScrollLeft), behavior: behavior || 'smooth' });
        } else {
          tabsNav.scrollLeft = Math.round(targetScrollLeft);
        }
        scheduleScrollStateUpdate();
      });
    }

    function getPanel(button) {
      var panelId = button && button.getAttribute('data-tab');
      if (!panelId) return null;
      var panel = document.getElementById(panelId);
      return panel && section.contains(panel) ? panel : null;
    }

    function preparePanel(panel) {
      if (!panel || panel.dataset.imagesPrepared === '1') return;
      panel.dataset.imagesPrepared = '1';
      panel.querySelectorAll('img[loading="lazy"]').forEach(function (image, index) {
        if (index < 5) {
          image.loading = 'eager';
          image.setAttribute('loading', 'eager');
          image.fetchPriority = 'high';
          image.setAttribute('fetchpriority', 'high');
        }
      });
    }

    function refreshPanelAnimations(panel) {
      if (!panel || !window.AOS || typeof window.AOS.refreshHard !== 'function') return;
      panel.querySelectorAll('[data-custom-tab-products-aos]').forEach(function (item) {
        item.classList.remove('aos-animate');
      });
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          window.AOS.refreshHard();
        });
      });
    }

    function activate(button, moveFocus) {
      var activePanel = getPanel(button);
      if (!activePanel) return;

      buttons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var isActive = panel === activePanel;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      section.style.setProperty('--tw-pc', button.getAttribute('data-weight-pc') || '400');
      section.style.setProperty('--tw-m', button.getAttribute('data-weight-mobile') || '400');
      preparePanel(activePanel);
      refreshPanelAnimations(activePanel);

      if (moveFocus) button.focus({ preventScroll: true });
      positionActiveTab(button, 'smooth');
    }

    section.addEventListener('click', function (event) {
      var button = event.target.closest('.tab-btn');
      if (button && section.contains(button)) activate(button, false);
    });

    function prewarmTab(event) {
      var button = event.target.closest('.tab-btn');
      if (button && section.contains(button)) preparePanel(getPanel(button));
    }

    section.addEventListener('pointerover', prewarmTab, { passive: true });
    section.addEventListener('focusin', prewarmTab);
    section.addEventListener('touchstart', prewarmTab, { passive: true });

    section.addEventListener('keydown', function (event) {
      var current = event.target.closest('.tab-btn');
      if (!current) return;
      var currentIndex = buttons.indexOf(current);
      var nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = buttons.length - 1;
      else return;

      event.preventDefault();
      activate(buttons[nextIndex], true);
    });

    var activeButton = section.querySelector('.tab-btn.is-active') || buttons[0];
    if (activeButton) preparePanel(getPanel(activeButton));

    if (tabsNav) {
      tabsNav.addEventListener('scroll', scheduleScrollStateUpdate, { passive: true });

      if (window.ResizeObserver) {
        var tabsResizeObserver = new ResizeObserver(function () {
          var currentActiveButton = section.querySelector('.tab-btn.is-active') || buttons[0];
          updateScrollState();
          positionActiveTab(currentActiveButton, 'auto');
        });
        tabsResizeObserver.observe(tabsNav);
        section._tabsResizeObserver = tabsResizeObserver;
      }

      positionActiveTab(activeButton, 'auto');
    }
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-custom-tab-products]')) initSection(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-custom-tab-products]').forEach(initSection);
    }
  }

  window.BoyaCustomTabProducts = { initAll: initAll };
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var unloadedSection = event.target.matches && event.target.matches('[data-custom-tab-products]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-custom-tab-products]');
    if (unloadedSection && unloadedSection._tabsResizeObserver) {
      unloadedSection._tabsResizeObserver.disconnect();
    }
  });
})();
